import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import ChartTrendline from "chartjs-plugin-trendline";
import ReactDOM from "react-dom/client";
import "react-notifications-component/dist/theme.css";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "store/config";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const totalizer = {
  id: "totalizer",

  beforeUpdate: function (chart: any) {
    chart.$totalizer = {
      totals: {},
    };
  },

  afterDatasetUpdate: (chart: any, { index: datasetIndex }: any) => {
    const dataset = chart.data.datasets[datasetIndex];
    const total = dataset.data.reduce((total: any, value: any, index: any) => {
      return total + (chart.legend.legendItems[index]?.hidden ? 0 : value || 0);
    }, 0);

    chart.$totalizer.totals[datasetIndex] = total;
  },
};

ChartJS.register(
  totalizer,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
  ChartTrendline,
  ArcElement,
  ChartDataLabels
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

reportWebVitals();

 